// src/pages/CheckoutCancel.jsx
import React,{useEffect} from 'react';
import { Link,useLocation } from 'react-router-dom';
import {track} from '../analytics/service';
import './checkout.css';

export default function CheckoutCancel() {
  const location=useLocation();
  useEffect(()=>{track('checkout_returned',{screen:'checkout_return',gateway:location.pathname.includes('paypal')?'paypal':'stripe',outcome:'cancelled'},`return:${location.key}`);},[location.key,location.pathname]);
  return (
    <div className="checkout-page">
      <div className="checkout-card">
        <div className="checkout-icon cancel">⚠️</div>
        <h1>Pagamento annullato</h1>
        <p className="muted">
          Nessun addebito è stato effettuato. Puoi modificare il carrello o riprovare il pagamento.
        </p>
        <div className="actions">
          <Link to="/ricercaservizi" className="btn">Continua a cercare servizi</Link>
        </div>
      </div>
    </div>
  );
}
